'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validation = require('utils/validation');

var _formValidation = require('helpers/formValidation');

var _formValidation2 = _interopRequireDefault(_formValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _validation.createValidator)({
  email: _formValidation2.default.emailNotRequired
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Account/EmailFormValidation.js
// module id = 1939
// module chunks = 1